<template>
    <v-layout v-bind:style='"width: " + ($vuetify.breakpoint.smAndUp? 75: 100 ) + "%; margin: auto;"' mt-5 column align-center justify-center>
        <v-container fluid pt-0>
            <v-list subheader xs12 :style = '`box-shadow: 0px 0px 20px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'>
                <v-flex class='px-2 mx-2 py-0 my-0'>
                    <v-text-field v-model='filterByName' append-icon='mdi-account-search-outline' single-line label='Поиск...' class='my-0'></v-text-field>
                </v-flex>
                <v-list-item @click='visibility.create = true;' v-if = '$store.getters.grantUsers > 1'>
                    <v-list-item-content>
                        <v-list-item-title>Создать пользователя</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>add</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-divider v-if = '!indicator'></v-divider>
                <v-progress-linear :color = '$store.getters.uiAccentIcon' height='1' class='ma-0' :active='indicator' v-if='indicator' :indeterminate='true'></v-progress-linear>
                <v-list-group no-action style='border-bottom: 1px solid;border-color:#EEEEEE;' v-for = '(ud, ui) in filteredPersons' :key='ui' v-if = '(pager - 1) * 10 <= ui && ui < pager * 10'>
                    <v-list-item slot="activator">
                        <v-list-item-avatar>
                            <img :src="ud.photo.length ? ud.photo: 'empty.png'">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ud.name}} {{ud.lastname}}</v-list-item-title>
                            <v-list-item-subtitle>{{ud.login}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if = 'ud.domain' class = 'mr-1'>
                            <v-chip style='user-select: none;' small outlined disabled :color = '$store.getters.uiAccentIcon'>{{ud.domain}}</v-chip>
                        </v-list-item-action>
                        <v-list-item-action v-if = 'ud.superuser'>
                            <v-chip style='user-select: none;' small outlined disabled color='light-blue lighten-2'>Администратор</v-chip>
                        </v-list-item-action>
                        <v-list-item-action v-if = '$store.getters.grantUsers > 0'>
                            <v-btn small depressed icon @click.stop.prevent = 'focusedUser = ud; visibility.grants = true;'>
                                <v-icon small>mdi-folder-account-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action v-if = '$store.getters.grantUsers > 3'>
                            <v-btn small depressed icon @click.stop.prevent='focusedUser = ud; visibility.update = true;'>
                                <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action class = 'mx-0' v-if = '$store.getters.grantUsers > 4'>
                            <v-btn small icon @click.stop.prevent='focusedUser = ud; visibility.delete = true;'>
                                <v-icon small :color = '$store.getters.uiAccentIcon'>delete_outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <template>
                        <v-list-item>
                            <v-list-item-action>
                                <span class='subheading font-weight-light'>Списки отчетов</span>
                            </v-list-item-action>
                            <v-spacer></v-spacer>
                            <v-list-item-content>
                                <v-list-item-title class='text-xs-right'>{{ud.mode_reports? "Создание, изменение и удаление": "Просмотр доступных"}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-action>
                                <span class='subheading font-weight-light'>Списки пользователей</span>
                            </v-list-item-action>
                            <v-spacer></v-spacer>
                            <v-list-item-content>
                                <v-list-item-title class='text-xs-right'>{{ud.mode_users? "Создание, изменение и удаление": "Доступ закрыт"}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-action>
                                <span class='subheading font-weight-light'>Списки проектов</span>
                            </v-list-item-action>
                            <v-spacer></v-spacer>
                            <v-list-item-content>
                                <v-list-item-title class='text-xs-right'>{{ud.mode_projects? "Создание, изменение и удаление": "Просмотр доступных"}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list-group>
                <v-list-item class = 'pt-2'>
                  <v-list-item-content style = 'align-items: center;'>
                    <v-pagination circle :color = '$store.getters.uiAccentIcon' total-visible = '10' :length = 'Math.round(filteredPersons.length / 10) + 1' v-model = 'pager'></v-pagination>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-container>
        <user-update :initialState.sync = 'visibility.update' :data = 'focusedUser' :postAction = 'getPersons'></user-update>
        <user-delete :initialState.sync = 'visibility.delete' :data = 'focusedUser' :postAction = 'getPersons'></user-delete>
        <user-create :initialState.sync = 'visibility.create' :postAction = 'getPersons' :restricted = 'existedLogins'></user-create>
        <user-grants :initialState.sync = 'visibility.grants' :data = 'focusedUser'></user-grants>
    </v-layout>
</template>
<script>
import { orderBy } from 'lodash-es'
import UserUpdate from '@/components/entities/users/UpdateDialog.vue'
import UserDelete from '@/components/entities/users/DeleteDialog.vue'
import UserCreate from '@/components/entities/users/CreateDialog.vue'
import Grants from '@/components/entities/users/grants/Controller.vue'

export default {
    components: {
      'user-update': UserUpdate,
      'user-delete': UserDelete,
      'user-create': UserCreate,
      'user-grants': Grants
    },
    data() {
        return {
            pager: 1,
            filterByName: '',
            visibility: {
                create: false,
                update: false,
                delete: false,
                grants: false
            },
            indicator: false,
            focusedUser: {},
            languages: [{ 'value': 'ru', 'text': 'Русский' }, { 'value': 'en', 'text': 'Английский' }],
            personsList: []
        }
    },
    methods: {
        getPersons: function() {
            this.indicator = true;
            this.$http.get( this.$store.getters.endpoint + '/db/persons', {
                emulateJSON: true,
                params: { 'login': this.$store.getters.userLogin },
                headers: this.$store.state.restrictedHeaders
            }).then((r) => {
                let response = r.body;
                if (response.result) {
                    this.personsList = orderBy(response.data, ['lastname', 'name']);
                    this.personsList = this.personsList.map( (r) => { return {...r, placeholder: r.name + ' ' + r.lastname}})
                    this.indicator = false;
                } else {
                    console.log(response)
                }
            })
        }
    },
    computed: {
        filteredPersons() {
            let q = this.filterByName.toLowerCase();
            let su = this.$store.getters.currentUser.superuser
            let branding = this.$store.state.brandingOption
            let visibleUsers = this.personsList.filter( (u) => (u.domain == branding) || !!su);
            let s = visibleUsers.filter((u) => u.placeholder.toLowerCase().includes(q) || u.login.includes(q))
            return s
        },
        existedLogins() {
            const logins = this.filteredPersons.map( (u) => u.login )
            return Array.from(new Set(logins))
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getPersons();
            vm.$store.commit('setBreadcrumbs', [
                { text: 'Главная', disabled: false, href: '#/' },
                { text: 'Пользователи', disabled: true, href: '#/users' }
            ]);
        });
    }
};
</script>